import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import useStores from '../../stores/useStore'
import { useTranslation } from 'react-i18next'
import AssetDataProvider , { useAssetDataState }from '../../stores/AssetDataProvider'
import { Alert, Spinner } from 'react-bootstrap'
import EditSubheader from '../../components/Assets/EditAsset/EditSubheader'
import Sidebar from '../../components/Assets/EditAsset/Sidebar'
import EditContentArea from '../../components/Assets/EditAsset/EditContentArea'
import { StyledJobfunctionContainer } from '../../components/Assets/Form/formHelper'
import styled from 'styled-components'
import { ContentArea } from '../../components/Page/logix2020/ContentArea'
import { TestSidebarRight } from '../../components/Page/logix2020/TestSidebarRight'
import BigFooter from '../../components/Footer/BigFooter'
import { FlexWrapper } from '../../components/Page/logix2020/FlexWrapper'
import { Observer } from 'mobx-react'
const StyledContentArea = styled(ContentArea)`
   padding: 20px 40px 20px 36px;
   @media (max-width: 1080px) {
    padding: 20px;
    min-height: calc(100vh - 488px);//header+navbar+sidebar=488px
   }
   .added-row {
    label {
      display: block;
    }
  }
`

const EditAssetPageContent = () => {
  const { assetId } = useParams()
  const { uiStore } = useStores()
  const { loadAssetData } = useAssetDataState()

  useEffect(() => {
    const init = async () => {
      loadAssetData(assetId)
    }
    init()
  }, [assetId, loadAssetData, uiStore])

  return (
    <>
      <EditSubheader />
      <FlexWrapper>
        <StyledContentArea>
          <EditContentArea />
        </StyledContentArea>
        <TestSidebarRight>
          <Sidebar />
        </TestSidebarRight>
      </FlexWrapper>
    </>
  )
}

const EditAssetPage = () => {
  const { uiStore } = useStores()
  const { t } = useTranslation()

  return (<Observer>{() => (
    <AssetDataProvider>
      <StyledJobfunctionContainer>
        {!uiStore.dashboard || !uiStore.allowAssetEntitiesAdministration
          ? (
            <FlexWrapper>
              <StyledContentArea>
                {!!uiStore.dashboard
                  ? <Alert variant="danger">{t('assetPage:accessDenied')}</Alert>
                  : <div className="d-flex align-items-center justify-content-center">< Spinner animation='border' variant='primary' /></div >
                }
              </StyledContentArea>
              <TestSidebarRight>
              </TestSidebarRight>
            </FlexWrapper>)
          :
          <EditAssetPageContent />
        }
        <BigFooter />
      </StyledJobfunctionContainer>
    </AssetDataProvider>
  )}</Observer>)
}

export default EditAssetPage
